import { enUS, esES, zhCN, jaJP, ptBR, plPL, elGR, itIT } from "@mui/material/locale";
import type { SupportedLocales } from "config/i18n";

const ENABLE_BETA_LOCALES = JSON.parse(process.env.REACT_APP_ENABLE_BETA_LOCALES || "false");

const PROD_LOCALES = ["en", "es", "zh-CN", "ja", "pt-BR", "pl"] as const;
const DEV_EXTRA_LOCALES = ["el-GR", "it"] as const;

export const AVAILABLE_LOCALES: SupportedLocales[] = ENABLE_BETA_LOCALES
  ? [...PROD_LOCALES, ...DEV_EXTRA_LOCALES]
  : [...PROD_LOCALES];

const MUI_LOCALE_REGISTRY = { enUS, esES, zhCN, jaJP, ptBR, plPL, elGR, itIT } as const;

export type MuiSupportedLocales = keyof typeof MUI_LOCALE_REGISTRY;

const MUI_LOCALES_MAP = {
  en: "enUS",
  es: "esES",
  "zh-CN": "zhCN",
  ja: "jaJP",
  "pt-BR": "ptBR",
  pl: "plPL",
  "el-GR": "elGR",
  it: "itIT",
} as const;

type MuiLocales = {
  [key in SupportedLocales]: MuiSupportedLocales;
};

class ThemeHelpers {
  static muiMapLocales: MuiLocales = MUI_LOCALES_MAP;

  /**
   *
   */
  static muiLocaleThemeConstructor(locale: SupportedLocales): object {
    const muiLocale = ThemeHelpers.muiMapLocales[locale] as MuiSupportedLocales;
    if (!muiLocale) return MUI_LOCALE_REGISTRY.enUS;

    const themeLocale = MUI_LOCALE_REGISTRY[muiLocale] || MUI_LOCALE_REGISTRY.enUS;
    return themeLocale;
  }
}

export default ThemeHelpers;
